import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import { setQrTemporaryConsent } from "../../lib/consent";
import { redirectAfterTracking } from "../../lib/ga4";
import { getRedirectBySlug } from "../../lib/redirects";

const wrapperStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  backgroundColor: "#0d0d0d",
  color: "#f5f1e8",
  textAlign: "center",
};

const cardStyle = {
  maxWidth: "560px",
};

const linkStyle = {
  color: "#d4af37",
};

function QrRedirect() {
  const { slug = "" } = useParams();
  const redirectEntry = getRedirectBySlug(slug);

  useEffect(() => {
    if (!redirectEntry?.url) {
      return;
    }

    setQrTemporaryConsent();
    redirectAfterTracking(slug, redirectEntry.campaign, redirectEntry.url);
  }, [redirectEntry, slug]);

  if (!redirectEntry?.url) {
    return (
      <div style={wrapperStyle}>
        <div style={cardStyle}>
          <h1>Link QR nie istnieje</h1>
          <p>Podany adres nie jest skonfigurowany w systemie redirectow.</p>
          <p>
            <Link to="/" style={linkStyle}>
              Wroc na strone glowna
            </Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={wrapperStyle}>
      <div style={cardStyle}>
        <h1>Przekierowujemy...</h1>
        <p>Za chwile otworzy sie docelowa strona.</p>
        <p>
          Jesli nic sie nie wydarzy, kliknij{" "}
          <a href={redirectEntry.url} style={linkStyle}>
            tutaj
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export default QrRedirect;
